<template>
  <v-container>
    <div>
      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-1"
        :search="search"
        v-model="selected"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" to="/admin/kegiatan/submit">Tambah Kegiatan</v-btn>
          </v-toolbar>
          <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
          ></v-text-field>
          <!-- DIALOG HAPUS KEGIATAN -->
          <v-dialog v-model="dialogDelete" max-width="600px">
            <v-card>
              <v-card-title>Apakah anda yakin akan menghapus data kegiatan ini?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="deleteConfirm" color="primary">hapus</v-btn>
                <v-btn @click="dialogDelete = false" color="secondary">batal</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon :to="'submitMember/' + item.masjid_program_uid" v-bind="attrs" v-on="on">
                <v-icon small> mdi-account-plus </v-icon>
              </v-btn>
            </template>
            <span>Tambahkan Anggota</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon :to="'listMember/' + item.masjid_program_uid" v-bind="attrs" v-on="on">
                <v-icon small> mdi-format-list-bulleted </v-icon>
              </v-btn>
            </template>
            <span>Lihat Anggota</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
              </v-btn>
            </template>
            <span>Hapus Kegiatan</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="toEdit(item)">
                <v-icon small> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Edit Kegiatan</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import router from "../../router"

export default {
  data() {
    return {
      search: "",
      dialogDelete: false,
      editedIndex: -1,
      editedId: {
        uid: "",
        masjidUid: ""
      },
      headers: [
        { text: "No", value: "no" },
        { text: "Tanggal", value: "start_date"},
        { text: "Jenis", value: "type"},
        { text: "Nama Kegiatan", value: "name" },
        { text: "Mulai Pukul", value: "start_time" },
        { text: "Berakhir Pukul", value: "end_time" },
        { text: "Aksi", value: "action" },
      ],
      items: [],
      selected: [],
    };
  },
  computed: {
    programId() {
      return this.selected[0].masjid_program_uid;
    },
  },
  mounted() {
    this.axios("program/list/")
      .then((response) => {
        console.log(response.data, 'res list program');
        this.items = response.data.data;
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].no = i + 1;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    deleteItem(item) {
      this.dialogDelete = true
      // console.log(item)
      this.editedId.uid = item.masjid_program_uid
      this.editedId.masjidUid = item.masjid.masjid_uid
      console.log(this.editedId)
      this.editedIndex = this.items.indexOf(item)
    },
    deleteConfirm() {
      this.axios.post(`/program/remove/${this.editedId.masjidUid}/${this.editedId.uid}`)
      .then((response) => {
        console.log(response)
        if(response.data.status == true) {
          this.items.splice(this.editedIndex, 1)
          for(let i = this.editedIndex; i <this.items.length; i++) {
            this.items[i].no = i+1
          }
        }
        this.dialogDelete = false
      })
      .catch((error) => {
        console.log(error)
        this.dialogDelete = false
      })
    },
    toEdit(item) {
      router.push(
        {
          name: "Tambahkan Kegiatan", 
          params: { id: item.masjid_program_uid }
        }
      )
    }
  }
};
</script>
